import React, { FC, useState } from "react";
import HealthInsurance from "./tabs/HealthInsurance";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";

const insuranceTabs = [
  {
    title: "Медицинское страхование",
    component: <HealthInsurance />,
  }
];

const Insurance: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {insuranceTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {insuranceTabs[tab].component}
    </Wrapper>
  );
};

export default Insurance;
